import {Component, HostBinding, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {Validators} from '@angular/forms';
import {Property} from '@aztrix/models';
import {PropertyRepresentation} from '@aztrix/sdk';
import {FormControl} from '@ngneat/reactive-forms';
import {Subscription} from 'rxjs';
import {startWith} from 'rxjs/operators';

import {AbstractProposalPropertyEdit} from '../../abstract-proposal-property-edit';

@Component({
  selector: 'ax-custom-radio-edit',
  templateUrl: 'custom-radio-edit.component.html',
  styleUrls: ['custom-radio-edit.component.scss', '../show-icon.scss'],
})
export class CustomRadioEditComponent
  extends AbstractProposalPropertyEdit
  implements OnInit, OnChanges, OnDestroy
{
  @HostBinding('class.c-property-edit') propertyEditClass = true;
  @HostBinding('class.showIcon') get showIconClass() {
    return this.showIcon;
  }
  radioControl = new FormControl();

  private _formSubscription = new Subscription();
  private _radioControlSubscription = new Subscription();
  private _touchedSubscriptions = new Subscription();

  ngOnInit(): void {
    this._radioControlSubscription = this.radioControl.valueChanges.subscribe((value) => {
      this.form.get('value')?.setValue(<string>value);
    });

    this._touchedSubscriptions.add(
      this.form.touch$.subscribe((touched) => {
        if (touched) {
          this.radioControl.markAsTouched();
        } else {
          this.radioControl.markAsUntouched();
        }
      })
    );

    this._touchedSubscriptions.add(
      this.radioControl.touch$.subscribe((touched) => {
        if (touched) {
          this.form.markAllAsTouched();
        } else {
          this.form.markAllAsTouched();
        }
      })
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.required) {
      if (this.required) {
        this.radioControl.setValidators(Validators.required);
      } else {
        this.radioControl.setValidators([]);
      }
    }

    if (changes.form && this.form) {
      this._formSubscription.unsubscribe();
      this._formSubscription = this.form.valueChanges
        .pipe(startWith(this.form.value))
        .subscribe((property: Property | PropertyRepresentation) => {
          if (this.radioControl.value !== property?.value) {
            this.radioControl.setValue(property?.value);
          }
        });

      this._disableChanges(this.form.disabled);
      this.valueControl?.registerOnDisabledChange((isDisabled) => this._disableChanges(isDisabled));

      this.radioControl.dirty$.subscribe((dirty) => {
        if (dirty) {
          this.valueControl?.markAsDirty();
        } else {
          this.valueControl?.markAsPristine();
        }
      });
    }
  }

  ngOnDestroy() {
    this._radioControlSubscription.unsubscribe();
    this._formSubscription.unsubscribe();
    this._touchedSubscriptions.unsubscribe();
  }

  get isSingleRadio(): boolean {
    return this.valueLabels ? this.valueLabels.length < 1 : true;
  }

  private _disableChanges(isDisabled: boolean) {
    if (isDisabled) {
      this.radioControl.disable({emitEvent: false});
    } else {
      this.radioControl.enable({emitEvent: false});
    }
  }
}
